import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={16.17}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21717 34519"
    {...props}
  >
    <path
      d="M10143 12568H5210L3355 34519h1438l1733-20519h3617v20519h1431V14000h3617l1734 20519h1436l-1854-21951h-4933v-2516h10143V0H0v10052h10143z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
